import React from 'react';
import { Editor } from 'slate';
import { Plugin, CustomEditor, CustomText } from '../types';

const UnderlinePlugin: Plugin = {
  name: 'underline',
  
  onKeyDown: (event: KeyboardEvent, editor: CustomEditor) => {
    if ((event.ctrlKey || event.metaKey) && event.key === 'u') {
      event.preventDefault();
      const marks = Editor.marks(editor) as CustomText;
      const isActive = marks?.underline === true;
      if (isActive) {
        Editor.removeMark(editor, 'underline');
      } else {
        Editor.addMark(editor, 'underline', true);
      }
      return true;
    }
    return false;
  },

  commands: {
    toggleUnderline: (editor: CustomEditor) => {
      const marks = Editor.marks(editor) as CustomText;
      const isActive = marks?.underline === true;
      if (isActive) {
        Editor.removeMark(editor, 'underline');
      } else {
        Editor.addMark(editor, 'underline', true);
      }
    }
  }
};

export default UnderlinePlugin; 